/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Video Export" |
*
* @param {Video_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_title = /** @type {((inputs?: Video_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videoexport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de vídeo")
	return /** @type {LocalizedString} */ ("Video Export")
});